"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: contacts/contacts-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcontacts%2Fcontacts-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactsServiceClient = exports.RecordsHashesResponseHashesEntry = exports.RecordsHashesResponse = exports.RecordsHashesRequest = exports.BucketsHashesResponseHashesEntry = exports.BucketsHashesResponse = exports.BucketsHashesRequest = exports.DataHashResponse = exports.DataHashRequest = exports.DeleteAddressBookResponse = exports.DeleteAddressBookRequest = exports.DeleteContactsResponse = exports.DeleteContactsRequest = exports.GetContactsResponse = exports.GetContactsRequest = exports.PutContactsResponse = exports.PutContactsRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const contacts_1 = require("./contacts");
const protobufPackage = 'com.step.contacts.proto';
function createBasePutContactsRequest() {
    return { addressBookId: '', contacts: [], version: contacts_1.ClientDataVersion.INVALID_DATA_VERSION };
}
exports.PutContactsRequest = {
    fromJSON(object) {
        const message = {
            addressBookId: isSet(object.addressBookId) ? globalThis.String(object.addressBookId) : '',
            contacts: globalThis.Array.isArray(object?.contacts)
                ? object.contacts.map((e) => contacts_1.Contact.fromJSON(e))
                : [],
        };
        if (isSet(object.version)) {
            message.version = (0, contacts_1.clientDataVersionFromJSON)(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressBookId !== '') {
            obj.addressBookId = message.addressBookId;
        }
        if (message.contacts?.length) {
            obj.contacts = message.contacts.map((e) => contacts_1.Contact.toJSON(e));
        }
        if (message.version !== undefined && message.version !== contacts_1.ClientDataVersion.INVALID_DATA_VERSION) {
            obj.version = (0, contacts_1.clientDataVersionToJSON)(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.PutContactsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePutContactsRequest();
        message.addressBookId = object.addressBookId ?? '';
        message.contacts = object.contacts?.map((e) => contacts_1.Contact.fromPartial(e)) || [];
        message.version = object.version ?? contacts_1.ClientDataVersion.INVALID_DATA_VERSION;
        return message;
    },
};
function createBasePutContactsResponse() {
    return { contacts: [] };
}
exports.PutContactsResponse = {
    fromJSON(object) {
        const message = {
            contacts: globalThis.Array.isArray(object?.contacts)
                ? object.contacts.map((e) => contacts_1.Contact.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.contacts?.length) {
            obj.contacts = message.contacts.map((e) => contacts_1.Contact.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.PutContactsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePutContactsResponse();
        message.contacts = object.contacts?.map((e) => contacts_1.Contact.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetContactsRequest() {
    return { addressBookId: '', referenceIds: [], version: contacts_1.ClientDataVersion.INVALID_DATA_VERSION };
}
exports.GetContactsRequest = {
    fromJSON(object) {
        const message = {
            addressBookId: isSet(object.addressBookId) ? globalThis.String(object.addressBookId) : '',
            referenceIds: globalThis.Array.isArray(object?.referenceIds)
                ? object.referenceIds.map((e) => globalThis.String(e))
                : [],
        };
        if (isSet(object.version)) {
            message.version = (0, contacts_1.clientDataVersionFromJSON)(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressBookId !== '') {
            obj.addressBookId = message.addressBookId;
        }
        if (message.referenceIds?.length) {
            obj.referenceIds = message.referenceIds;
        }
        if (message.version !== undefined && message.version !== contacts_1.ClientDataVersion.INVALID_DATA_VERSION) {
            obj.version = (0, contacts_1.clientDataVersionToJSON)(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.GetContactsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetContactsRequest();
        message.addressBookId = object.addressBookId ?? '';
        message.referenceIds = object.referenceIds?.map((e) => e) || [];
        message.version = object.version ?? contacts_1.ClientDataVersion.INVALID_DATA_VERSION;
        return message;
    },
};
function createBaseGetContactsResponse() {
    return { contacts: [] };
}
exports.GetContactsResponse = {
    fromJSON(object) {
        const message = {
            contacts: globalThis.Array.isArray(object?.contacts)
                ? object.contacts.map((e) => contacts_1.Contact.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.contacts?.length) {
            obj.contacts = message.contacts.map((e) => contacts_1.Contact.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetContactsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetContactsResponse();
        message.contacts = object.contacts?.map((e) => contacts_1.Contact.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDeleteContactsRequest() {
    return { addressBookId: '', referenceIds: [], version: contacts_1.ClientDataVersion.INVALID_DATA_VERSION };
}
exports.DeleteContactsRequest = {
    fromJSON(object) {
        const message = {
            addressBookId: isSet(object.addressBookId) ? globalThis.String(object.addressBookId) : '',
            referenceIds: globalThis.Array.isArray(object?.referenceIds)
                ? object.referenceIds.map((e) => globalThis.String(e))
                : [],
        };
        if (isSet(object.version)) {
            message.version = (0, contacts_1.clientDataVersionFromJSON)(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressBookId !== '') {
            obj.addressBookId = message.addressBookId;
        }
        if (message.referenceIds?.length) {
            obj.referenceIds = message.referenceIds;
        }
        if (message.version !== undefined && message.version !== contacts_1.ClientDataVersion.INVALID_DATA_VERSION) {
            obj.version = (0, contacts_1.clientDataVersionToJSON)(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.DeleteContactsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeleteContactsRequest();
        message.addressBookId = object.addressBookId ?? '';
        message.referenceIds = object.referenceIds?.map((e) => e) || [];
        message.version = object.version ?? contacts_1.ClientDataVersion.INVALID_DATA_VERSION;
        return message;
    },
};
function createBaseDeleteContactsResponse() {
    return {};
}
exports.DeleteContactsResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeleteContactsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDeleteContactsResponse();
        return message;
    },
};
function createBaseDeleteAddressBookRequest() {
    return { addressBookId: '', version: contacts_1.ClientDataVersion.INVALID_DATA_VERSION };
}
exports.DeleteAddressBookRequest = {
    fromJSON(object) {
        const message = {
            addressBookId: isSet(object.addressBookId) ? globalThis.String(object.addressBookId) : '',
        };
        if (isSet(object.version)) {
            message.version = (0, contacts_1.clientDataVersionFromJSON)(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressBookId !== '') {
            obj.addressBookId = message.addressBookId;
        }
        if (message.version !== undefined && message.version !== contacts_1.ClientDataVersion.INVALID_DATA_VERSION) {
            obj.version = (0, contacts_1.clientDataVersionToJSON)(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.DeleteAddressBookRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeleteAddressBookRequest();
        message.addressBookId = object.addressBookId ?? '';
        message.version = object.version ?? contacts_1.ClientDataVersion.INVALID_DATA_VERSION;
        return message;
    },
};
function createBaseDeleteAddressBookResponse() {
    return {};
}
exports.DeleteAddressBookResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeleteAddressBookResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseDeleteAddressBookResponse();
        return message;
    },
};
function createBaseDataHashRequest() {
    return { addressBookId: '', version: contacts_1.ClientDataVersion.INVALID_DATA_VERSION };
}
exports.DataHashRequest = {
    fromJSON(object) {
        const message = {
            addressBookId: isSet(object.addressBookId) ? globalThis.String(object.addressBookId) : '',
        };
        if (isSet(object.version)) {
            message.version = (0, contacts_1.clientDataVersionFromJSON)(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressBookId !== '') {
            obj.addressBookId = message.addressBookId;
        }
        if (message.version !== undefined && message.version !== contacts_1.ClientDataVersion.INVALID_DATA_VERSION) {
            obj.version = (0, contacts_1.clientDataVersionToJSON)(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.DataHashRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDataHashRequest();
        message.addressBookId = object.addressBookId ?? '';
        message.version = object.version ?? contacts_1.ClientDataVersion.INVALID_DATA_VERSION;
        return message;
    },
};
function createBaseDataHashResponse() {
    return { hash: '' };
}
exports.DataHashResponse = {
    fromJSON(object) {
        const message = {
            hash: isSet(object.hash) ? globalThis.String(object.hash) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.hash !== '') {
            obj.hash = message.hash;
        }
        return obj;
    },
    create(base) {
        return exports.DataHashResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDataHashResponse();
        message.hash = object.hash ?? '';
        return message;
    },
};
function createBaseBucketsHashesRequest() {
    return { addressBookId: '', bucketCount: 0, version: contacts_1.ClientDataVersion.INVALID_DATA_VERSION };
}
exports.BucketsHashesRequest = {
    fromJSON(object) {
        const message = {
            addressBookId: isSet(object.addressBookId) ? globalThis.String(object.addressBookId) : '',
        };
        if (isSet(object.bucketCount)) {
            message.bucketCount = globalThis.Number(object.bucketCount);
        }
        if (isSet(object.version)) {
            message.version = (0, contacts_1.clientDataVersionFromJSON)(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressBookId !== '') {
            obj.addressBookId = message.addressBookId;
        }
        if (message.bucketCount !== undefined && message.bucketCount !== 0) {
            obj.bucketCount = Math.round(message.bucketCount);
        }
        if (message.version !== undefined && message.version !== contacts_1.ClientDataVersion.INVALID_DATA_VERSION) {
            obj.version = (0, contacts_1.clientDataVersionToJSON)(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.BucketsHashesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBucketsHashesRequest();
        message.addressBookId = object.addressBookId ?? '';
        message.bucketCount = object.bucketCount ?? 0;
        message.version = object.version ?? contacts_1.ClientDataVersion.INVALID_DATA_VERSION;
        return message;
    },
};
function createBaseBucketsHashesResponse() {
    return { hashes: {} };
}
exports.BucketsHashesResponse = {
    fromJSON(object) {
        const message = {
            hashes: isObject(object.hashes)
                ? Object.entries(object.hashes).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.hashes) {
            const entries = Object.entries(message.hashes);
            if (entries.length > 0) {
                obj.hashes = {};
                entries.forEach(([k, v]) => {
                    obj.hashes[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.BucketsHashesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBucketsHashesResponse();
        message.hashes = Object.entries(object.hashes ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseBucketsHashesResponseHashesEntry() {
    return { key: '', value: '' };
}
exports.BucketsHashesResponseHashesEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.BucketsHashesResponseHashesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBucketsHashesResponseHashesEntry();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseRecordsHashesRequest() {
    return {
        addressBookId: '',
        bucketIndex: 0,
        bucketCount: 0,
        version: contacts_1.ClientDataVersion.INVALID_DATA_VERSION,
    };
}
exports.RecordsHashesRequest = {
    fromJSON(object) {
        const message = {
            addressBookId: isSet(object.addressBookId) ? globalThis.String(object.addressBookId) : '',
        };
        if (isSet(object.bucketIndex)) {
            message.bucketIndex = globalThis.Number(object.bucketIndex);
        }
        if (isSet(object.bucketCount)) {
            message.bucketCount = globalThis.Number(object.bucketCount);
        }
        if (isSet(object.version)) {
            message.version = (0, contacts_1.clientDataVersionFromJSON)(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressBookId !== '') {
            obj.addressBookId = message.addressBookId;
        }
        if (message.bucketIndex !== undefined && message.bucketIndex !== 0) {
            obj.bucketIndex = Math.round(message.bucketIndex);
        }
        if (message.bucketCount !== undefined && message.bucketCount !== 0) {
            obj.bucketCount = Math.round(message.bucketCount);
        }
        if (message.version !== undefined && message.version !== contacts_1.ClientDataVersion.INVALID_DATA_VERSION) {
            obj.version = (0, contacts_1.clientDataVersionToJSON)(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.RecordsHashesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordsHashesRequest();
        message.addressBookId = object.addressBookId ?? '';
        message.bucketIndex = object.bucketIndex ?? 0;
        message.bucketCount = object.bucketCount ?? 0;
        message.version = object.version ?? contacts_1.ClientDataVersion.INVALID_DATA_VERSION;
        return message;
    },
};
function createBaseRecordsHashesResponse() {
    return { hashes: {} };
}
exports.RecordsHashesResponse = {
    fromJSON(object) {
        const message = {
            hashes: isObject(object.hashes)
                ? Object.entries(object.hashes).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.hashes) {
            const entries = Object.entries(message.hashes);
            if (entries.length > 0) {
                obj.hashes = {};
                entries.forEach(([k, v]) => {
                    obj.hashes[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.RecordsHashesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordsHashesResponse();
        message.hashes = Object.entries(object.hashes ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseRecordsHashesResponseHashesEntry() {
    return { key: '', value: '' };
}
exports.RecordsHashesResponseHashesEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.RecordsHashesResponseHashesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecordsHashesResponseHashesEntry();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    },
};
/**
 * Contacts public API.
 */
class ContactsServiceClient {
    rpc;
    name = 'com.step.contacts.proto.ContactsService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/contacts';
    methods = [{
            name: 'PutContacts',
            requestType: exports.PutContactsRequest,
            responseType: exports.PutContactsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetContacts',
            requestType: exports.GetContactsRequest,
            responseType: exports.GetContactsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'DeleteContacts',
            requestType: exports.DeleteContactsRequest,
            responseType: exports.DeleteContactsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'DeleteAddressBook',
            requestType: exports.DeleteAddressBookRequest,
            responseType: exports.DeleteAddressBookResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'DataHash',
            requestType: exports.DataHashRequest,
            responseType: exports.DataHashResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'BucketsHashes',
            requestType: exports.BucketsHashesRequest,
            responseType: exports.BucketsHashesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RecordsHashes',
            requestType: exports.RecordsHashesRequest,
            responseType: exports.RecordsHashesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Upsert a list of contacts into the store in a batch.
     * List of contacts is in the body of the request.
     */
    putContacts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a batch of current contacts from the store.
     * List of contact ids is in the body of the request.
     */
    getContacts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Removes contacts from the store in a batch.
     * List of contact ids is in the body of the request.
     */
    deleteContacts(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Removes all contacts belonging to an address book.
     */
    deleteAddressBook(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Computes aggregated hash of the data for address book.
     */
    dataHash(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns aggregated hashes for all buckets.
     */
    bucketsHashes(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns a map of record IDs to computed data hash for a specific bucket.
     */
    recordsHashes(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.ContactsServiceClient = ContactsServiceClient;
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=contacts-service.js.map